export default __webpack_public_path__ + "static/media/banner-bg-3.d57f1742.png";